// @flow
import type { AgreementSpecification } from 'digicel-kaizen-library';

export type AgreementsActionType =
  | {|
      type: 'FETCH_AGREEMENTS_BY_PRODUCT_OFFERINGS',
      payload: {|
        isSignup?: boolean,
        options: ?(Option[]),
      |},
    |}
  | {|
      type: 'SET_AGREEMENT_SPECIFICATIONS',
      payload: {|
        agreementSpecifications: AgreementSpecification[],
      |},
    |}
  | {|
      type: 'CLEAR_AGREEMENTS',
    |}
  | {|
      type: 'TOGGLE_SELECTED_AGREEMENT',
      payload: {|
        agreementOuid: string,
      |},
    |};

export const fetchAgreementsByProductOfferings = (isSignup?: boolean, options?: Option[]): AgreementsActionType => ({
  type: 'FETCH_AGREEMENTS_BY_PRODUCT_OFFERINGS',
  payload: {
    isSignup,
    options,
  },
});

export const setAgreementSpecifications = (
  agreementSpecifications: AgreementSpecification[]
): AgreementsActionType => ({
  type: 'SET_AGREEMENT_SPECIFICATIONS',
  payload: {
    agreementSpecifications,
  },
});

export const toggleSelectedAgreement = (agreementOuid: string): AgreementsActionType => ({
  type: 'TOGGLE_SELECTED_AGREEMENT',
  payload: {
    agreementOuid,
  },
});

export const clearAgreements = (): AgreementsActionType => ({
  type: 'CLEAR_AGREEMENTS',
});

export type Option = {
  name: string,
  type: string,
};
